import type React from "react";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getIntegrationNameFromUrl } from "app/pages/sales-intelligence/common-components/export-table/getIntegrationNameFromUrl";
import { selectHsIsNotIntegrated } from "app/pages/sales-intelligence/sub-modules/management/store/selectors/hubspotSelectors";
import { selectIsSalesForceNotIntegrated } from "app/pages/sales-intelligence/sub-modules/management/store/selectors/salesforceSelectors";
import { selectDynamicsIsNotIntegrated } from "app/pages/sales-intelligence/sub-modules/management/store/selectors/dynamicsSelectors";
import { proNavigator } from "single-spa/react-app/ProNavigator";
import type { Integration } from "app/pages/sales-intelligence/sub-modules/management/types";
import { getSalesforceStatusThunk } from "app/pages/sales-intelligence/sub-modules/management/store/effects/salesforce/status";
import { getHubspotStatusThunk } from "app/pages/sales-intelligence/sub-modules/management/store/effects/hubspot/status";
import { getDynamicsStatusThunk } from "app/pages/sales-intelligence/sub-modules/management/store/effects/dynamics/status";
import { MANAGEMENT_CRM_INTEGRATIONS_ROUTE } from "app/pages/sales-intelligence/constants/sl_routes";

export const withConnectionCheck = <T extends object>(Component: React.ComponentType<T>) => {
    return function (props: T) {
        const { integrationName } = getIntegrationNameFromUrl();
        const dispatch = useDispatch();
        const [isStatusChecked, setIsStatusChecked] = useState(false);

        const allProps = {
            salesforce: selectIsSalesForceNotIntegrated,
            hubspot: selectHsIsNotIntegrated,
            dynamics: selectDynamicsIsNotIntegrated,
        };

        const getStatus = {
            salesforce: getSalesforceStatusThunk,
            hubspot: getHubspotStatusThunk,
            dynamics: getDynamicsStatusThunk,
        };

        const isNotIntegrated = useSelector(allProps[integrationName as Integration]);

        useEffect(() => {
            if (isNotIntegrated) {
                if (isStatusChecked) {
                    proNavigator.go(MANAGEMENT_CRM_INTEGRATIONS_ROUTE);
                } else {
                    dispatch(getStatus[integrationName as Integration]()).then(() => setIsStatusChecked(true));
                }
            }
        }, [isNotIntegrated, isStatusChecked, integrationName]);

        return <Component {...props} />;
    };
};
